module.exports = __webpack_public_path__ + "media/svg-new/monitor-e7daf21c.svg";